import classNames from "classnames";
import React, { CSSProperties } from "react";
import { Icon, IconName } from "../components";

interface SecondaryButtonProps {
  title: string;
  onPress?: () => void;
  disabled?: boolean;
  size?: "lg" | "md";
  icon?: IconName;
  override?: {
    button?: {
      style: CSSProperties;
    };
  };
}

export function SecondaryButton(props: SecondaryButtonProps) {
  const { title, icon, disabled, onPress, size = "md", override } = props;

  return (
    <button
      disabled={disabled}
      className={classNames(
        "secondary-button",
        `secondary-button-size-${size}`,
        disabled && "secondary-button-disabled"
      )}
      style={override?.button?.style}
      onClick={onPress}
    >
      {icon && (
        <div className="secondary-button-icon">
          <Icon size={16} name={icon} />
        </div>
      )}
      <span>{title}</span>
    </button>
  );
}
